<template>
  <div class="root">
    <div class="title bg-purple">中转情况</div>
    <el-form class="form" size="mini" label-position="left" label-width="100px">
      <el-form-item label="中转公司">{{trans.carrierName}}</el-form-item>
      <el-form-item label="本地电话">{{trans.localPhone}}</el-form-item>
      <el-form-item label="提货电话">{{trans.transferPhone}}</el-form-item>
      <el-form-item label="提货地址">{{trans.transferAddress}}</el-form-item>
      <el-form-item label="中转单号">{{trans.number}}</el-form-item>
      <el-form-item label="中转送货费">{{trans.sendFee}}</el-form-item>
      <el-form-item label="中转运费">{{trans.baseFreight}}</el-form-item>
      <el-form-item label="经办人">{{trans.createUserName}}</el-form-item>
      <el-form-item label="中转备注">{{trans.remarks}}</el-form-item>
    </el-form>
  </div>
</template>

<script>
export default {
  props: {
    waybillSplitId: {},
  },
  data() {
    return {
      trans: {
        carrierName: "",
        localPhone: "",
        number: "",
        sendFee: "",
        baseFreight: "",
        createUserName: "",
        remarks: "",
        transferPhone: "",
        transferAddress: "",
      },
    };
  },
  watch: {
    waybillSplitId(val) {
      if (!val) {
        return;
      }
      this.getData();
    },
  },
  mounted(){
    this.getData()
  },
  methods: {
    async getData() {
      if(!this.waybillSplitId){
        return
      }
      const res = await this.$API.runDetail({
        number: "admin_waybill_sum_all_trans_info_v5",
        waybillSplitId: this.waybillSplitId,
      });
      this.trans = res;
    },
  },
};
</script>

<style lang="less" scoped>
.root {
  width: 100%;
  height: 100%;
  .title {
    display: flex;
    justify-content: center;
    height: 35px;
    line-height: 35px;
  }
  .el-form {
    .el-form-item {
      margin-bottom: 0;
    }
  }
}
</style>